module.exports = __webpack_public_path__ + "static/img/deve5.1c30317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve5.png
// module id = 9XTU
// module chunks = 1